import { render, staticRenderFns } from "./RequestForm.vue?vue&type=template&id=2fa91fc9&"
import script from "./RequestForm.vue?vue&type=script&lang=js&"
export * from "./RequestForm.vue?vue&type=script&lang=js&"
import style0 from "./RequestForm.vue?vue&type=style&index=0&id=2fa91fc9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports